import { render, staticRenderFns } from "./CurrencyAnswer.vue?vue&type=template&id=cfe003f2&"
import script from "./CurrencyAnswer.vue?vue&type=script&lang=js&"
export * from "./CurrencyAnswer.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyAnswer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports